export default {
  p: { margin: 0 },
};
